import { render } from "./BaseGridTable.vue?vue&type=template&id=a177e6c6&scoped=true"
import script from "./BaseGridTable.vue?vue&type=script&lang=js"
export * from "./BaseGridTable.vue?vue&type=script&lang=js"

import "./BaseGridTable.vue?vue&type=style&index=0&id=a177e6c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a177e6c6"]])

export default __exports__